@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.loader {
  width: 30px;
}

.forgotPasswordWrapper {
  width: 100%;
  padding: 40px 16px;
  border-radius: 16px;
  border: 2px solid v.$gray-border-panel-color;
  background: v.$gradient-form-card;
  backdrop-filter: blur(1px);

  @media (min-width: 768px) {
    padding: 40px;
    max-width: 440px;
    margin: 0 auto;
  }
}

.forgotPasswordTitle {
    @include t.text(36px, 48px, "bold");
    color: v.$white-color;
    margin-bottom: 16px;
}

.formButton {
  cursor: pointer;
  width: 100%;
  display: flex;
  height: 48px;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  gap: 8px;
  background: v.$green-color;
  @include t.text(16px, 26px, "semi-bold");
  color: v.$white-color;

  &:disabled {
    cursor: not-allowed;
  }
}

.formDescriptionLink {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin: 16px auto;
  color: v.$gray-light-color;
  @include t.text(14px, 22px, "normal");

  span {
    cursor: pointer;
    text-decoration: underline;
  }
}

.errorMessage {
  text-align: center;
  margin-top: 4px;
  color: v.$error-color;
  @include t.text(12px, 20px, "medium");
}

.successMessage {
  position: absolute;
  bottom: 154px;
  color: v.$gray-light-color;
  @include t.text(12px, 20px, "medium");
}

/* Chinese Brothers */

.forgotPasswordWrapperChineseBrothers {
  border: 1px solid v.$chinese-brothers-border-color;
  background: v.$chinese-brothers-card-bg;
}

.formButtonChineseBrothers {
  background: v.$white-color;
  color: v.$navy-dark-color-2;
}